var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.toastData)?_c('div',{staticClass:"toast-wrapper"},[_c('p',{staticClass:"toast-inner"},[_vm._v(" "+_vm._s(_vm.toastData.text)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }